import styled from 'styled-components'

export const MailToLink = styled.a`
    color: #333333;
    
    &:hover {
        color: #333333;
    }
`

export const CopyrightText = styled.div`
    background-color: #333333;
    padding-top: 3px;
    padding-bottom: 3px;
    text-align: center;
    
    p {
        margin-top: 1rem;
    }
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Footer.js